import type { UserVersion } from "../index";

/**
 * is v1 a newer version as compared to v2
 * @param v1
 * @param v2
 * @returns boolean
 */
export function isNewerVersion(v1: UserVersion, v2?: UserVersion) {
  if (!v2) {
    return true;
  }
  return (
    v1.version > v2.version ||
    (v1.version === v2.version && v1.userId.localeCompare(v2.userId) < 0)
  );
}
